<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" mat-dialog-title></app-layout-dialogheader1>
<mat-dialog-content>
    <div class="container-fluid container-clean">
        <div class="row issue container-clean">
            <div class="col container-clean">
                <app-issuecanvas [issue]="issue" [bgimage]="imageurl" [width]="640" [height]="512"></app-issuecanvas>
            </div>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end mat-dialog-actions">
    <!-- <button mat-raised-button type="button" class="btn btn-primary pull-right">Ok vale continuar</button> -->
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>

